Vue.component('navbar-main', require('./layout/NavbarMain.vue').default);
Vue.component('navbar-internal', require('./layout/NavbarInternal.vue').default);
Vue.component('processes-team', require('./layout/ProcessesTeam.vue').default);
Vue.component('filters-roles', require('./layout/FiltersRoles.vue').default);
Vue.component('banner', require('./layout/Banner.vue').default);
Vue.component('session-expired', require('./layout/SessionExpired.vue').default);

Vue.component('radar-index', require('./radar/index.vue').default);

Vue.component('password-change', require('./password/passwordChange.vue').default);

Vue.component('users-index', require('./users/index.vue').default);

Vue.component('norm-search', require('./search/normSearch.vue').default);
Vue.component('theme-search', require('./search/themeSearch.vue').default);
Vue.component('search-partials-actions', require('./search/partials/Actions.vue').default);
Vue.component('search-partials-compliance', require('./search/partials/Compliance.vue').default);

Vue.component('update-index', require('./update/index.vue').default);

Vue.component('reports-index', require('./reports/index.vue').default);
Vue.component('reports-form-accomplishment', require('./reports/formAccomplishment.vue').default);
Vue.component('reports-form-homework', require('./reports/formHomework.vue').default);
Vue.component('reports-form-regulatory-update', require('./reports/formRegulatoryUpdates.vue').default);
Vue.component('reports-form-processes-compliance', require('./reports/formProcessesCompliance.vue').default);
Vue.component('reports-form-access', require('./reports/formAccess.vue').default);
Vue.component('reports-form-user-access', require('./reports/formUserAccess.vue').default);
Vue.component('reports-form-processes', require('./reports/formProcesses.vue').default);
Vue.component('reports-form-processes-details', require('./reports/formProcessesDetails.vue').default);

Vue.component('processes-detail-compliance-edit', require('./processesDetail/complianceEdit.vue').default);
Vue.component('processes-detail-compliance-evidence-edit', require('./processesDetail/complianceEvidenceEdit.vue').default);
Vue.component('processes-detail-process-task-rule-affair-detail', require('./processesDetail/processTaskRuleAffairDetail.vue').default);
Vue.component('processes-detail-process-task-rule-detail', require('./processesDetail/processTaskRuleDetail.vue').default);
Vue.component('processes-detail-process-task-rule-detail-view', require('./processesDetail/processTaskRuleDetailView.vue').default);
Vue.component('processes-detail-process-task-observations-updates', require('./processesDetail/processTaskObservationsUpdates.vue').default);
Vue.component('processes-detail-process-task-edit', require('./processesDetail/processTaskEdit.vue').default);
Vue.component('processes-detail-process-affair', require('./processesDetail/processAffair.vue').default);
Vue.component('processes-detail-edit-process', require('./processesDetail/processEdit.vue').default);
Vue.component('processes-detail-process-affair-add', require('./processesDetail/processAffairAdd.vue').default);

Vue.component('create-tenant-first-step', require('./tenants/firstStep.vue').default);
Vue.component('create-tenant-second-step', require('./tenants/secondStep.vue').default);
Vue.component('create-tenant-third-step', require('./tenants/thirdStep.vue').default);
Vue.component('create-tenant-footer', require('./tenants/footer.vue').default);

Vue.component('regulatory-affairs-form', require('./regulatoryAffairs/index.vue').default);
Vue.component('detail-affair', require('./regulatoryAffairs/detail.vue').default);

Vue.component('list-rules', require('./rules/listRules.vue').default);
Vue.component('add-rule', require('./rules/addRule.vue').default);
Vue.component('edit-rule', require('./rules/editRule.vue').default);

Vue.component('view-compliance', require('./compliance/viewCompliance.vue').default);
Vue.component('edit-compliance', require('./compliance/editCompliance.vue').default);
Vue.component('add-rule-compliance', require('./compliance/addRuleCompliance.vue').default);
Vue.component('add-compliance', require('./compliance/addComplieance.vue').default);
Vue.component('history-compliance', require('./compliance/historyCompliance.vue').default);


Vue.component('form-topic', require('./topics_subtopics/FormTopic').default);
Vue.component('form-subtopic', require('./topics_subtopics/FormSubtopic').default);

/**
 * Structuring Reports
 */
Vue.component('reports-index-structuring', require('./reportsStructuring/index.vue').default);
Vue.component('reports-form-detail-process', require('./reportsStructuring/formDetailProcess.vue').default)
Vue.component('reports-form-detail-affairs', require('./reportsStructuring/formDetailAffairs.vue').default)
Vue.component('reports-form-detail-audit', require('./reportsStructuring/formDetailAudit.vue').default)
Vue.component('reports-form-audit-email-alerts', require('./reportsStructuring/formAuditEmailAlerts.vue').default)

Vue.component('confirm-dialog', require('./processesDetail/confirmDialog').default)

// OAuth
Vue.component('oauth-login-with-btn', require('./oauth/LoginWithProvidersBtn.vue').default);
